var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockTicked = function SvgClockTicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 22.5c4.142-4.142 4.142-10.858 0-15s-10.858-4.142-15 0-4.142 10.858 0 15 10.858 4.142 15 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.564 18V9a1.065 1.065 0 1 0-2.13 0l.008 7.942-4.943-.007a1.065 1.065 0 0 0 0 2.13h6A1.063 1.063 0 0 0 17.564 18"
  })));
};
export default SvgClockTicked;